<template>
  <div class="btn-wrapper" v-show="loaded">
    <button
      class="green"
      type="button"
      :class="{'applied': deadline}"
      :disabled="deadline"
      @click.prevent="clickBtn"
      id="getEventUrl"
    >
      {{ buttonLabel }}
    </button>
  </div>
</template>

<script>
import { getEventUrl } from '@/helpers/utils.js'
export default {
  data: () => ({
    isDisabled: false
  }),
  props: {
    loaded: {
      type: Boolean,
      required: true
    },
    isAuthed: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    entryBefore () {
      return this.$moment().isBefore('2020-10-22', 'day')
    },
    finishFesta () {
      return this.$moment().isAfter('2020-10-31', 'day')
    },
    archiveDeadline () {
      return this.$moment().isBetween('2020-10-24 15:00:00', '2020-10-31 23:59:59')
    },
    buttonLabel () {
      if (this.entryBefore) {
        return '無料参加チケットを取得'
      } else if (this.archiveDeadline) {
        return 'アーカイブ抽選会に応募する(10/31まで)'
      } else if (this.finishFesta) {
        return '終了しました'
      } else {
        return '抽選会に応募する(14:00まで)'
      }
    },
    deadline () {
      const now = this.$moment(new Date())
      const deadlineAt1031 = this.$moment('2020-10-31 23:59:59')
      // 10/31以降だったら申し込みできない
      if (now.diff(deadlineAt1031) > 0) {
        return true
      }
      const entryBefore = this.$moment().isBefore('2020-10-22', 'day')
      const archiveDeadline = this.$moment().isBetween('2020-10-24 15:00:00', '2020-10-31 23:59:59')
      const deadline1022 = this.$moment().isBetween('2020-10-22 00:00:00', '2020-10-22 13:59:59')
      const deadline1023 = this.$moment().isBetween('2020-10-23 00:00:00', '2020-10-23 13:59:59')
      const deadline1024 = this.$moment().isBetween('2020-10-24 00:00:00', '2020-10-24 13:59:59')
      return !entryBefore && !archiveDeadline && !deadline1022 && !deadline1023 && !deadline1024
    }
  },
  methods: {
    clickBtn () {
      let attachUrl
      if (this.entryBefore) {
        attachUrl = getEventUrl('https://l-ma.co.jp/events/6433')
        window.open(attachUrl, '_blank')
        return
      }
      if (!this.isAuthed) {
        this.$emit('to-login')
        return
      }
      if (this.$moment().isBetween('2020-10-22 00:00:00', '2020-10-22 13:59:59')) {
        window.open('https://ws.formzu.net/dist/S38766662/', '_blank')
      } else if (this.$moment().isBetween('2020-10-23 00:00:00', '2020-10-23 13:59:59')) {
        window.open('https://ws.formzu.net/dist/S59207973/', '_blank')
      } else if (this.$moment().isBetween('2020-10-24 00:00:00', '2020-10-24 13:59:59')) {
        window.open('https://ws.formzu.net/dist/S29808694/', '_blank')
      } else if (this.$moment().isBetween('2020-10-24 15:00:00', '2020-10-31 23:59:59')) {
        window.open('https://ws.formzu.net/dist/S61946280/', '_blank')
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.btn-wrapper
  width: 100%
  max-width: 320px
  margin: 0 auto
  button
    display: flex
    justify-content: center
    align-items: center
    width: 100%
    height: 56px
    color: #fff
    background-color: $green
    border: none
    border-radius: 8px
    padding: 0
    margin: 0 auto
    font-size: 1.5rem
    cursor: pointer
  .applied
    background-color: gray
</style>
